const AuthCheckLoader = () => {
  return (
    <div
      data-testid="auth-loading"
      className="h-svh flex justify-center items-center bg-body/50"
    >
      <h1 className="uppercase font-bold text-[48px]">
        Vérification de session...
      </h1>
      ;
    </div>
  );
};

export default AuthCheckLoader;
